



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// getAllApprovedPlansWithCreatorAndApprover
// GETALLAPPROVEDPLANSWITHCREATORANDAPPROVER


const GETALLAPPROVEDPLANSWITHCREATORANDAPPROVER= createAsyncThunk(
  "getAllApprovedPlansWithCreatorAndApprover/getAllApprovedPlansWithCreatorAndApprover",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllApprovedPlansWithCreatorAndApproverSlice = createSlice({
  name: "getAllApprovedPlansWithCreatorAndApproverSlice",
  initialState: {
    getAllApprovedPlansWithCreatorAndApprover: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllApprovedPlansWithCreatorAndApprover: (state) => {
        state.getAllApprovedPlansWithCreatorAndApprover.loading = false
        state.getAllApprovedPlansWithCreatorAndApprover.error = false
        state.getAllApprovedPlansWithCreatorAndApprover.data = []
        state.getAllApprovedPlansWithCreatorAndApprover.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLAPPROVEDPLANSWITHCREATORANDAPPROVER.fulfilled, (state, action) => {
      state.getAllApprovedPlansWithCreatorAndApprover = {
        ...state.getAllApprovedPlansWithCreatorAndApprover,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLAPPROVEDPLANSWITHCREATORANDAPPROVER.pending, (state, action) => {
      state.getAllApprovedPlansWithCreatorAndApprover = {
        ...state.getAllApprovedPlansWithCreatorAndApprover,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLAPPROVEDPLANSWITHCREATORANDAPPROVER.rejected, (state, action) => {
      state.getAllApprovedPlansWithCreatorAndApprover = {
        ...state.getAllApprovedPlansWithCreatorAndApprover,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllApprovedPlansWithCreatorAndApproverAction = {
    GETALLAPPROVEDPLANSWITHCREATORANDAPPROVER,
};

export { getAllApprovedPlansWithCreatorAndApproverAction };
export default getAllApprovedPlansWithCreatorAndApproverSlice.reducer;
export const {setInitialStateOfgetAllApprovedPlansWithCreatorAndApprover} = getAllApprovedPlansWithCreatorAndApproverSlice.actions
